import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["memory", "syncToStorage", "storage"],
    _excluded2 = ["combo", "component", "adapter", "props", "formProps", "after"],
    _excluded3 = ["after", "props", "formProps", "message", "messageType", "messageOpen"],
    _excluded4 = ["setField", "getField", "dispatch"],
    _excluded5 = ["fields", "common", "showConfirm", "memory", "syncToStorage", "resetToStorage", "storage", "storageData"],
    _excluded6 = ["component", "name", "reducer", "valueHandler"],
    _excluded7 = ["actionType", "defaultReducer", "getState", "setState", "setContext", "getContext", "changedState", "fieldCache"],
    _excluded8 = ["formProps", "props", "message"],
    _excluded9 = ["formProps", "props"],
    _excluded10 = ["getFields", "changedGroup"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { Group, INIT } from '@jd/jmtd-group';
import Loading from '@jd/jmtd/es/Loading';
import Form from '@jd/jmtd/es/Form';
import FormItem from '@jd/jmtd/es/FormItem';
import { findLastIndex, fromTo, toObject } from '@jd/jmtd-tools/es/generator';
import { clone, forOwn, iterate, mapValue } from '@jd/jmtd-tools/es/object';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { flat, top } from '@jd/jmtd-tools/es/array';
import ButtonGroup from '@jd/jmtd/es/ButtonGroup';
import { isFunction } from '@jd/jmtd-tools/es/is';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
import Message from '@jd/jmtd/es/Message';
import classNames from '@jd/jmtd-tools/es/classnames';
import { getValue } from '@jd/jmtd/es/tools/util';
import FormButtons from '@jd/jmtd/es/FormButtons';
import { setClass } from '@jd/jmtd-tools/es/element';
import ResizeObserver from 'resize-observer-polyfill';
import * as sessionStorage from '@jd/jmtd-tools/es/session-storage';
import * as localStorage from '@jd/jmtd-tools/es/local-storage';
import { insert, iteratee, LinkedList, remove } from '@jd/jmtd-tools/es/linked-list';
import { trackEvent as _trackEvent } from '@jd/jmtd/es/tools/eventTracking';
import { parse } from '@jd/jmtd-tools/es/url';
import { fieldsToObject, fieldsToValue } from '../tools/groups';
import { affixCardContext } from '../AffixCard';
import FormGroupConfirmButton from '../FormGroupConfirmButton';
import FormGroupResetButton from '../FormGroupResetButton';
import FormGroupMoreButton from '../FormGroupMoreButton';
import { FormGroupContext } from './context';
import { Adapters } from './adapter';
var componentName = 'Group';
var MESSAGE_TIMEOUT = Symbol('messageTimeout');
var CHANGE = Symbol('change');
var renderList = LinkedList();
var RESTORE = Symbol('restore');
var memoryKey = ''; // 记忆key，当key变化时清除原有的记忆

var globalMemoryVersion = 1; // 全局记忆规则版本

var openSessionKey = 'form-group-open';
export function setMemoryKey(key) {
  memoryKey = key;
}

function toSupportName(name) {
  return "__".concat(name);
}

export function getStorageName(name, _ref, // group参数
_ref2) {
  var memorySessionKey = _ref.memorySessionKey,
      memory = _ref.memory;
  var _ref2$storageSubKey = _ref2.storageSubKey,
      storageSubKey = _ref2$storageSubKey === void 0 ? [] : _ref2$storageSubKey,
      enableMemory = _ref2.enableMemory,
      memorySubKey = _ref2.memorySubKey,
      memoryVersion = _ref2.memoryVersion;
  // 字段参数
  return [!enableMemory && memorySessionKey ? "session-form-group:".concat(memorySessionKey) : 'form-group', name].concat(memory ? memorySubKey !== null && memorySubKey !== void 0 ? memorySubKey : storageSubKey : storageSubKey) // 记忆子key
  .concat(memory && memoryVersion ? memoryVersion : []) // 记忆版本
  .join('-');
} // 处理组参数默认值

function getGroupDefaultProps(_ref3) {
  var memory = _ref3.memory,
      _ref3$syncToStorage = _ref3.syncToStorage,
      syncToStorage = _ref3$syncToStorage === void 0 ? memory || null : _ref3$syncToStorage,
      _ref3$storage = _ref3.storage,
      storage = _ref3$storage === void 0 ? memory ? localStorage : sessionStorage : _ref3$storage,
      other = _objectWithoutProperties(_ref3, _excluded);

  return _objectSpread({
    memory: memory,
    syncToStorage: syncToStorage,
    storage: storage
  }, other);
}

var FormGroupRender = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormGroupRender, _PureComponent);

  var _super = _createSuper(FormGroupRender);

  function FormGroupRender(props) {
    var _this;

    _classCallCheck(this, FormGroupRender);

    _this = _super.call(this, props);
    _this.expanded = false;
    return _this;
  }

  _createClass(FormGroupRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var ref = this.ref,
          _this$props = this.props,
          groupName = _this$props.groupName,
          onChange = _this$props.props.onChange;
      this.node = {
        groupName: groupName,
        onChange: onChange
      };
      insert(renderList, this.node);
      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        _this2.resize();
      });
      resizeObserver.observe(ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      remove(renderList, this.node);
      this.resizeObserver.disconnect();
    }
  }, {
    key: "resize",
    value: function resize() {
      var ref = this.ref,
          hasMoreButton = this.hasMoreButton,
          affixed = this.affixed,
          affixExpanded = this.affixExpanded,
          expanded = this.expanded,
          showMore = this.props.showMore;

      if (!hasMoreButton) {
        return;
      } // 计算按钮的位置


      var formItems = _toConsumableArray(ref.querySelectorAll('.jmtd-form-item:not(.jmtd-form-buttons)'));

      var formButtons = ref.querySelector('.jmtd-form-buttons');
      var firstItem = formItems[0];
      formItems.forEach(function (item) {
        removeCss(item, 'padding-right');
      }); // 如果吸顶，使用吸顶展开状态，否则使用组件内部展开状态

      var curExpand = affixed ? affixExpanded : expanded;

      if (firstItem) {
        var form = formButtons.parentElement;
        var formItemStyle = window.getComputedStyle(firstItem);
        var marginV = parseInt(formItemStyle.marginBottom, 10); // 水平间距

        var itemTops = _toConsumableArray(formItems).map(function (item) {
          return item.offsetTop;
        });

        var topValues = _toConsumableArray(new Set(itemTops));

        var totalLineCount = topValues.length; // 总行数

        var lastItemIndex; // 可视区域最后一项的索引

        var shrinkLineCount = affixed ? 1 : 2;
        var lastItem = top(formItems);

        if ((showMore || affixed) && !curExpand && shrinkLineCount < totalLineCount) {
          var targetTop = topValues[shrinkLineCount - 1];
          lastItemIndex = findLastIndex(itemTops, function (t) {
            return t === targetTop;
          });
        } else {
          lastItemIndex = formItems.length - 1;
        } // 设置可视的最后一项的padding-right，为按钮留出空间


        var _iterator = _createForOfIteratorHelper(fromTo(lastItemIndex, formItems.length)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var index = _step.value;
            css(formItems[index], 'padding-right', px(formButtons.offsetWidth));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        topValues = _toConsumableArray(new Set(_toConsumableArray(formItems).map(function (item) {
          return item.offsetTop;
        })));
        var enableMore = affixed || shrinkLineCount < topValues.length && showMore; // 是否启用展示更多按钮

        setClass(ref, 'jmtp-form-group-disable-more', !enableMore); // 是否禁用more

        setClass(ref, 'jmtp-form-group-expanded', curExpand); // 是否展开

        var shrink = enableMore && !curExpand;
        setClass(ref, 'jmtp-form-group-shrink', shrink); // 是否展开
        // 设置form的高度

        css(form, 'height', px(shrink ? topValues[shrinkLineCount] : lastItem.offsetTop + lastItem.offsetHeight + marginV));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          groupName = _this$props2.groupName,
          ready = _this$props2.ready,
          fields = _this$props2.fields,
          showLoading = _this$props2.showLoading,
          className = _this$props2.className,
          showGroupConfirm = _this$props2.showConfirm,
          _this$props2$showRese = _this$props2.showReset,
          showGroupReset = _this$props2$showRese === void 0 ? showGroupConfirm : _this$props2$showRese,
          confirmButtonProps = _this$props2.confirmButtonProps,
          _this$props2$fieldSho = _this$props2.fieldShowConfirm,
          fieldShowConfirm = _this$props2$fieldSho === void 0 ? !showGroupConfirm : _this$props2$fieldSho,
          loading = _this$props2.loading,
          _confirm = _this$props2.confirm,
          _reset = _this$props2.reset,
          showMore = _this$props2.showMore,
          alwaysTriggerChange = _this$props2.alwaysTriggerChange,
          onReset = _this$props2.onReset,
          _this$props2$enableAf = _this$props2.enableAffix,
          enableAffix = _this$props2$enableAf === void 0 ? groupName === 'Header' : _this$props2$enableAf,
          hiddenWhenAffixed = _this$props2.hiddenWhenAffixed,
          noFormWrap = _this$props2.noFormWrap,
          buttons = _this$props2.props.buttons;
      var lastCombo;
      var formLoading = showLoading && (!ready || fields.some(function (item) {
        var _item$state;

        return (_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.formLoading;
      }));
      return /*#__PURE__*/React.createElement(ConfigConsumer, {
        context: affixCardContext
      }, function (_ref4) {
        var affix = _ref4.affix,
            affixed = _ref4.affixed,
            affixExpanded = _ref4.affixExpanded,
            setFormGroup = _ref4.setFormGroup,
            setExpanded = _ref4.setExpanded;
        return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref5) {
          var locale = _ref5.locale,
              proLocale = _ref5.proLocale;
          // eslint-disable-next-line no-unused-expressions
          setFormGroup === null || setFormGroup === void 0 ? void 0 : setFormGroup(_this3);
          _this3.affixed = affixed;
          _this3.affixExpanded = affixExpanded;
          var hasMoreButton = _this3.hasMoreButton = (showMore || affix) && enableAffix;
          var defaultButtons = []; // 默认按钮

          if (hasMoreButton) {
            defaultButtons.push( /*#__PURE__*/React.createElement(FormGroupMoreButton, {
              key: "more"
            }));
          }

          if (showGroupReset) {
            defaultButtons.push( /*#__PURE__*/React.createElement(FormGroupResetButton, {
              key: "reset"
            }));
          }

          if (showGroupConfirm) {
            defaultButtons.push( /*#__PURE__*/React.createElement(FormGroupConfirmButton, {
              key: "confirm"
            }));
          }

          var formContent = /*#__PURE__*/React.createElement(React.Fragment, null, fields.map(function (_ref6, index) {
            var _adapter$render, _adapter;

            var setState = _ref6.setState,
                fieldName = _ref6.name,
                _ref6$config = _ref6.config,
                combo = _ref6$config.combo,
                Component = _ref6$config.component,
                adapter = _ref6$config.adapter,
                _ref6$config$props = _ref6$config.props,
                fixedProps = _ref6$config$props === void 0 ? {} : _ref6$config$props,
                _ref6$config$formProp = _ref6$config.formProps,
                fixedFormProps = _ref6$config$formProp === void 0 ? {} : _ref6$config$formProp,
                fixedAfter = _ref6$config.after,
                fixedConfig = _objectWithoutProperties(_ref6$config, _excluded2),
                _ref6$state = _ref6.state,
                state = _ref6$state === void 0 ? {} : _ref6$state,
                fieldReady = _ref6.ready,
                context = _ref6.context,
                setContext = _ref6.setContext,
                fieldLoading = _ref6.loading,
                fieldCache = _ref6.fieldCache;

            if (!Component) {
              return null;
            }

            var _state$after = state.after,
                after = _state$after === void 0 ? fixedAfter : _state$after,
                _state$props = state.props,
                props = _state$props === void 0 ? {} : _state$props,
                _state$formProps = state.formProps,
                formProps = _state$formProps === void 0 ? {} : _state$formProps,
                message = state.message,
                messageType = state.messageType,
                messageOpen = state.messageOpen,
                otherState = _objectWithoutProperties(state, _excluded3);

            var _fixedConfig$otherSta = _objectSpread(_objectSpread({}, fixedConfig), otherState),
                _fixedConfig$otherSta2 = _fixedConfig$otherSta.visible,
                visible = _fixedConfig$otherSta2 === void 0 ? true : _fixedConfig$otherSta2,
                rawLabel = _fixedConfig$otherSta.label,
                trackLabel = _fixedConfig$otherSta.trackLabel; // 使用语言获取label


            var label = getValue(rawLabel, {
              locale: locale,
              proLocale: proLocale
            });

            var componentProps = _objectSpread(_objectSpread({
              onChange: function onChange(nextValue) {
                setState(_objectSpread(_objectSpread({}, state), {}, {
                  props: _objectSpread(_objectSpread({}, state.props), {}, {
                    value: nextValue
                  })
                }), CHANGE);

                try {
                  var _ref7;

                  _trackEvent({
                    componentName: componentName,
                    locationName: "".concat(groupName, "-").concat(fieldName, "-").concat((_ref7 = trackLabel !== null && trackLabel !== void 0 ? trackLabel : rawLabel) !== null && _ref7 !== void 0 ? _ref7 : fieldName),
                    eventName: 'change',
                    eventValue: JSON.stringify(nextValue)
                  }); // eslint-disable-next-line no-empty

                } catch (_unused) {}
              }
            }, fixedProps), props); // 加载适配器


            if (adapter === undefined) {
              adapter = Adapters.get(Component);
            }

            adapter = (_adapter$render = (_adapter = adapter) === null || _adapter === void 0 ? void 0 : _adapter.render) !== null && _adapter$render !== void 0 ? _adapter$render : function (x) {
              return x;
            }; // 使用适配器转换props

            var _adapter2 = adapter({
              component: Component,
              showConfirm: fieldShowConfirm,
              loading: fieldLoading,
              props: componentProps,
              context: context,
              setContext: setContext,
              cache: fieldCache
            }),
                _adapter2$component = _adapter2.component,
                RenderComponent = _adapter2$component === void 0 ? Component : _adapter2$component,
                _adapter2$props = _adapter2.props,
                renderedProps = _adapter2$props === void 0 ? componentProps : _adapter2$props;

            var messageComponent = /*#__PURE__*/React.createElement(Message, {
              type: messageType,
              open: messageOpen
            }, message); // 如果处于combo状态，处理combo
            // combo：多项通过InputGroup组合为一项

            if (combo || lastCombo) {
              lastCombo = lastCombo || [];
              lastCombo.push({
                after: after,
                fieldReady: fieldReady,
                visible: visible,
                formProps: _objectSpread(_objectSpread({
                  label: label
                }, fixedFormProps), formProps),
                component: visible && /*#__PURE__*/React.createElement(RenderComponent, _extends({
                  key: index
                }, renderedProps))
              }); // 如果项设置了combo，不渲染，仅处理message

              if (combo) {
                return /*#__PURE__*/React.createElement(Fragment, {
                  key: index
                }, messageComponent);
              }
            }

            var itemProps;
            var itemVisible;
            var itemReady;

            if (lastCombo) {
              // 结算combo，combo
              itemReady = lastCombo.every(function (i) {
                return i.fieldReady;
              });
              itemVisible = lastCombo.some(function (i) {
                return i.visible;
              });
              itemProps = _objectSpread(_objectSpread({}, lastCombo[0].formProps), {}, {
                children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonGroup, null, lastCombo.map(function (i) {
                  return i.component;
                })), lastCombo.map(function (i, afterIndex) {
                  return /*#__PURE__*/React.createElement(Fragment, {
                    key: afterIndex
                  }, i.after);
                }))
              });
              lastCombo = null;
            } else {
              itemReady = fieldReady;
              itemVisible = visible;
              itemProps = _objectSpread(_objectSpread(_objectSpread({
                label: label
              }, fixedFormProps), formProps), {}, {
                children: fieldReady && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderComponent, renderedProps), after)
              });
            }

            return /*#__PURE__*/React.createElement(Fragment, {
              key: index
            }, itemVisible && itemReady && (noFormWrap ? itemProps.children : /*#__PURE__*/React.createElement(FormItem, _extends({
              className: classNames('jmtd-form-group-form-item', _defineProperty({}, "jmtd-form-group-form-item-field-".concat(fieldName), !!fieldName))
            }, itemProps))), messageComponent);
          }), !!defaultButtons.length && /*#__PURE__*/React.createElement(FormGroupContext.Provider, {
            value: {
              locale: locale,
              confirmButtonProps: _objectSpread({
                disabled: loading || fields.some(function (item) {
                  var _item$state2;

                  return (_item$state2 = item.state) === null || _item$state2 === void 0 ? void 0 : _item$state2.disabled;
                })
              }, confirmButtonProps),
              confirm: function confirm() {
                _confirm(alwaysTriggerChange);
              },
              reset: function reset() {
                _reset();

                onReset();
              },
              more: function more() {
                if (affixed) {
                  setExpanded(!affixExpanded);
                } else {
                  _this3.expanded = !_this3.expanded;

                  _this3.forceUpdate();
                }
              },
              trackEvent: function trackEvent(eventName) {
                _trackEvent({
                  componentName: componentName,
                  locationName: groupName,
                  eventName: eventName
                });
              }
            }
          }, /*#__PURE__*/React.createElement(FormButtons, {
            "data-component-name": "FormGroup",
            className: classNames({
              'jmtp-form-group-fixed-buttons': hasMoreButton
            })
          }, buttons !== null && buttons !== void 0 ? buttons : defaultButtons)));
          return /*#__PURE__*/React.createElement("div", {
            className: classNames('jmtp-form-group', className, {
              'jmtp-form-group-affix': hasMoreButton,
              'jmtp-form-group-loading': formLoading,
              'jmtp-form-group-hidden-when-affixed': hiddenWhenAffixed
            }),
            ref: function ref(el) {
              _this3.ref = el;
            }
          }, /*#__PURE__*/React.createElement(Loading, {
            loading: formLoading,
            autoMinHeight: true
          }, noFormWrap ? formContent : /*#__PURE__*/React.createElement(Form, {
            inline: true
          }, formContent)));
        });
      });
    }
  }]);

  return FormGroupRender;
}(PureComponent);

FormGroupRender.propTypes = {
  fields: PropTypes.array,
  ready: PropTypes.bool,
  showConfirm: PropTypes.bool,
  loading: PropTypes.bool,
  confirm: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  fieldShowConfirm: PropTypes.bool,
  showMore: PropTypes.bool,
  className: PropTypes.string,
  groupName: PropTypes.string,
  props: PropTypes.object,
  showReset: PropTypes.bool,
  alwaysTriggerChange: PropTypes.bool,
  onReset: PropTypes.func,
  enableAffix: PropTypes.func,
  confirmButtonProps: PropTypes.object,
  hiddenWhenAffixed: PropTypes.bool,
  noFormWrap: PropTypes.bool,
  showLoading: PropTypes.bool
};
FormGroupRender.defaultProps = {
  fields: [],
  ready: true,
  showConfirm: false,
  loading: false,
  fieldShowConfirm: undefined,
  showMore: false,
  className: '',
  groupName: '',
  props: {},
  showReset: undefined,
  onReset: function onReset() {},
  alwaysTriggerChange: false,
  enableAffix: undefined,
  confirmButtonProps: null,
  hiddenWhenAffixed: false,
  noFormWrap: false,
  showLoading: true
};
export default function FormGroup(_ref8) {
  var groups = _ref8.groups,
      _ref8$onChange = _ref8.onChange,
      _onChange = _ref8$onChange === void 0 ? function () {} : _ref8$onChange,
      _ref8$onError = _ref8.onError,
      onError = _ref8$onError === void 0 ? function (e) {
    // eslint-disable-next-line no-console
    console.error('FormGroup error', e);
  } : _ref8$onError;

  var initialized = false;
  var commonFieldsMap = {};
  var storageToClear = {};
  var currentDump = {}; // 处理open带过来的session数据

  var openStorageData = JSON.parse(sessionStorage.getItem(openSessionKey)); // 检查url是否匹配

  if (!openStorageData || location.pathname === openStorageData.url) {
    openStorageData = null;
  }

  var _Group = Group({
    groups: toObject(iterate(groups), function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          groupRawProps = _ref10[0],
          groupName = _ref10[1];

      var groupConfig = getGroupDefaultProps(groupRawProps);

      var rawFields = groupConfig.fields,
          rawCommon = groupConfig.common,
          showConfirm = groupConfig.showConfirm,
          memory = groupConfig.memory,
          syncToStorage = groupConfig.syncToStorage,
          resetToStorage = groupConfig.resetToStorage,
          storage = groupConfig.storage,
          storageData = groupConfig.storageData,
          groupProps = _objectWithoutProperties(groupConfig, _excluded5);

      var groupComponents = {};
      var fieldsMap = {}; // 字段表

      // 字段表
      var storageItems = {}; // 存储数据

      // 存储数据
      var common = groupName === 'Header' || groupName === 'Time' || rawCommon; // 处理fields，将各种复杂的fields结构打平
      // 目前支持：
      // 1. field是函数
      // 2. fields是数组

      // 处理fields，将各种复杂的fields结构打平
      // 目前支持：
      // 1. field是函数
      // 2. fields是数组
      var fields = flat(rawFields.map(function (field) {
        return isFunction(field) ? field() : field;
      }));
      fields.forEach(function (field) {
        var name = field.name,
            Components = field.Components;
        fieldsMap[name] = field;

        if (common) {
          commonFieldsMap[name] = field;
        }

        Object.assign(groupComponents, Components !== null && Components !== void 0 ? Components : {});
      }); // 读取记忆内容

      // 读取记忆内容
      if (syncToStorage) {
        var infoKey = "".concat(syncToStorage, "-info");

        try {
          if (openStorageData) {
            var _openStorageData, _openStorageData$data;

            // open参数
            storageItems = (_openStorageData = openStorageData) === null || _openStorageData === void 0 ? void 0 : (_openStorageData$data = _openStorageData.data) === null || _openStorageData$data === void 0 ? void 0 : _openStorageData$data[groupName];
          } else {
            // 记忆
            if (memory) {
              var sessionIdKey = "".concat(syncToStorage, "-session-id");
              var sessionId = sessionStorage.getItem(sessionIdKey) || "".concat(new Date().getTime()); // 对话id，如果没有新起一个

              // 对话id，如果没有新起一个
              var storageInfo = JSON.parse(storage.getItem(infoKey));
              var now = new Date().getTime();

              if (storageInfo) {
                // 当key变化时，或者记忆规则版本变化时，或者超过14天，清除存储
                if (storageInfo.key !== memoryKey || storageInfo.version !== globalMemoryVersion || now - storageInfo.lastUpdate > 1000 * 60 * 60 * 24 * 14) {
                  storage.removeItem(infoKey);
                  storage.removeItem(syncToStorage);
                }
              } // 新会话清除session字段


              // 新会话清除session字段
              if (!storageInfo || storageInfo.sessionId !== sessionId) {
                var _storageContent = storage.getItem(syncToStorage);

                if (_storageContent) {
                  storageItems = JSON.parse(_storageContent);
                  Object.keys(storageItems).forEach(function (key) {
                    if (key.indexOf('session-form-group') === 0) {
                      delete storageItems[key];
                    }
                  });
                  storage.setItem(syncToStorage, JSON.stringify(storageItems));
                }
              } // 存储sessionId和storageInfo


              // 存储sessionId和storageInfo
              sessionStorage.setItem(sessionIdKey, sessionId);
              storage.setItem(infoKey, JSON.stringify({
                sessionId: sessionId,
                version: globalMemoryVersion,
                key: memoryKey,
                lastUpdate: now
              }));
            }

            var storageContent = storage.getItem(syncToStorage);

            if (storageContent) {
              storageItems = JSON.parse(storageContent);
            }
          }
        } catch (e) {
          // 清除相关的key
          memory && storage.removeItem(infoKey);
          storage.removeItem(syncToStorage); // eslint-disable-next-line no-console

          // eslint-disable-next-line no-console
          console.error('FormGroup storage parse失败', e);
          storageItems = {};
        }
      }

      if (storageData) {
        Object.assign(storageItems, storageData);
      } // 存储镜像，如果设置了resetToStorage，重置时恢复为该镜像


      // 存储镜像，如果设置了resetToStorage，重置时恢复为该镜像
      var storageImages = {};

      try {
        storageImages = clone(storageItems);
      } catch (_unused2) {
        console.error('记忆读取失败');
      }

      return [groupName, _objectSpread(_objectSpread({}, groupProps), {}, {
        syncToStorage: syncToStorage,
        storage: storage,
        showConfirm: showConfirm,
        common: common,
        groupComponents: groupComponents,
        reducer: function reducer(_ref11) {
          var actionType = _ref11.actionType,
              actionData = _ref11.actionData,
              dispatch = _ref11.dispatch;

          // 如果设置了resetToStorage，恢复到存储镜像
          if (resetToStorage && actionType === Group.RESET && groupName === actionData) {
            Object.assign(storageItems, storageImages);
          } // 处理restore


          // 处理restore
          if (actionType === RESTORE && groupName === actionData.groupName) {
            if (resetToStorage) {
              // 如果设置了resetToStorage，直接更新存储镜像即可
              storageImages = clone(actionData.image); // 更新存储镜像
            } else {
              // 回复存储数据
              Object.assign(storageItems, actionData.image);
            }

            dispatch(Group.RESET, groupName);
          }
        },
        fields: flat(fields.map(function (_ref12) {
          var component = _ref12.component,
              name = _ref12.name,
              _reducer = _ref12.reducer,
              _ref12$valueHandler = _ref12.valueHandler,
              valueHandler = _ref12$valueHandler === void 0 ? function (state) {
            var _state$props2;

            return state === null || state === void 0 ? void 0 : (_state$props2 = state.props) === null || _state$props2 === void 0 ? void 0 : _state$props2.value;
          } : _ref12$valueHandler,
              other = _objectWithoutProperties(_ref12, _excluded6);

          var supportName = toSupportName(name);
          return [_objectSpread(_objectSpread({
            justForRender: true,
            component: component,
            name: name
          }, other), {}, {
            reducer: function reducer(_ref13) {
              return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var actionType, defaultReducer, getState, _setState, setContext, getContext, changedState, fieldCache, otherArg, getProps, _Adapters$get, adapterReducer;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        getProps = function _getProps() {
                          var _fieldsMap$targetName, _getState$targetName;

                          var targetName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : name;

                          var _ref14 = (_fieldsMap$targetName = fieldsMap[targetName]) !== null && _fieldsMap$targetName !== void 0 ? _fieldsMap$targetName : commonFieldsMap[targetName],
                              _ref14$props = _ref14.props,
                              fixedProps = _ref14$props === void 0 ? {} : _ref14$props;

                          var _ref15 = (_getState$targetName = getState()[targetName]) !== null && _getState$targetName !== void 0 ? _getState$targetName : {},
                              _ref15$props = _ref15.props,
                              props = _ref15$props === void 0 ? {} : _ref15$props;

                          return _objectSpread(_objectSpread({}, fixedProps), props);
                        };

                        actionType = _ref13.actionType, defaultReducer = _ref13.defaultReducer, getState = _ref13.getState, _setState = _ref13.setState, setContext = _ref13.setContext, getContext = _ref13.getContext, changedState = _ref13.changedState, fieldCache = _ref13.fieldCache, otherArg = _objectWithoutProperties(_ref13, _excluded7);
                        _context.prev = 2;

                        if (!_reducer) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 6;
                        return _reducer(_objectSpread({
                          // 获取存储的值
                          getStorage: function getStorage() {
                            var targetName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : name;
                            var storageName = getStorageName(targetName, groupConfig, fieldsMap[targetName]);
                            var result = storageItems[storageName];
                            delete storageItems[storageName];
                            return result;
                          },
                          actionType: actionType,
                          fieldCache: fieldCache,
                          setContext: setContext,
                          getContext: getContext,
                          changedState: changedState,
                          getState: getState,
                          triggerByOnChange: actionType === CHANGE && changedState[name],
                          // 由onChange触发
                          getProps: getProps,
                          overwriteState: function overwriteState(next, setActionType) {
                            _setState(next, setActionType);
                          },
                          setState: function setState() {
                            var _getState$name;

                            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                _ref16$formProps = _ref16.formProps,
                                nextFormProps = _ref16$formProps === void 0 ? {} : _ref16$formProps,
                                _ref16$props = _ref16.props,
                                nextProps = _ref16$props === void 0 ? {} : _ref16$props,
                                message = _ref16.message,
                                next = _objectWithoutProperties(_ref16, _excluded8);

                            var setActionType = arguments.length > 1 ? arguments[1] : undefined;

                            var _ref17 = (_getState$name = getState()[name]) !== null && _getState$name !== void 0 ? _getState$name : {},
                                formProps = _ref17.formProps,
                                props = _ref17.props,
                                prev = _objectWithoutProperties(_ref17, _excluded9);

                            var messageOpen = false;

                            if (message) {
                              clearTimeout(fieldCache[MESSAGE_TIMEOUT]);
                              fieldCache[MESSAGE_TIMEOUT] = setTimeout(function () {
                                _setState(_objectSpread(_objectSpread({}, getState()[name]), {}, {
                                  messageOpen: false
                                }), setActionType);
                              }, 3000);
                              messageOpen = true;
                            } else {
                              message = prev.message;
                            }

                            _setState(_objectSpread(_objectSpread(_objectSpread({
                              formProps: _objectSpread(_objectSpread({}, formProps), nextFormProps),
                              props: _objectSpread(_objectSpread({}, props), nextProps)
                            }, prev), next), {}, {
                              message: message,
                              messageOpen: messageOpen
                            }), setActionType);
                          },
                          clearStorage: function clearStorage(list) {
                            if (memory) {
                              var _storageToClear$group;

                              var set = (_storageToClear$group = storageToClear[groupName]) !== null && _storageToClear$group !== void 0 ? _storageToClear$group : storageToClear[groupName] = {};
                              list.forEach(function (x) {
                                set[x] = true;
                              });
                            }
                          }
                        }, otherArg));

                      case 6:
                        _context.next = 10;
                        break;

                      case 8:
                        _context.next = 10;
                        return defaultReducer();

                      case 10:
                        adapterReducer = (_Adapters$get = Adapters.get(component)) === null || _Adapters$get === void 0 ? void 0 : _Adapters$get.reducer;

                        if (!(adapterReducer && changedState[name])) {
                          _context.next = 14;
                          break;
                        }

                        _context.next = 14;
                        return adapterReducer({
                          showConfirm: !showConfirm,
                          getProps: getProps,
                          setContext: setContext,
                          getContext: getContext
                        });

                      case 14:
                        _context.next = 19;
                        break;

                      case 16:
                        _context.prev = 16;
                        _context.t0 = _context["catch"](2);
                        onError(_context.t0);

                      case 19:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 16]]);
              }))();
            }
          }), {
            // 辅助字段，响应value变化
            support: true,
            name: supportName,
            reducer: function reducer(_ref18) {
              var changedState = _ref18.changedState,
                  getState = _ref18.getState,
                  setState = _ref18.setState;

              if (changedState[name]) {
                var state = getState();
                var value = valueHandler(state[name]);

                if (value !== state[supportName]) {
                  setState(value);
                }
              }
            }
          }];
        }))
      })];
    }),
    render: FormGroupRender,
    onChange: function onChange(_ref19) {
      var _getFields = _ref19.getFields,
          changedGroup = _ref19.changedGroup,
          other = _objectWithoutProperties(_ref19, _excluded10);

      _onChange(_objectSpread(_objectSpread({}, other), {}, {
        changedGroup: changedGroup,
        // 获取name-value键值对
        getFields: function getFields(groupName, config) {
          return fieldsToValue(_getFields(groupName), config);
        },
        // 获取name-props键值对
        getRawFields: function getRawFields(groupName) {
          return fieldsToObject(_getFields(groupName));
        }
      })); // TAG 处理storage


      // TAG 处理storage
      forOwn(changedGroup, function (_, groupName) {
        var groupConfig = getGroupDefaultProps(groups[groupName]);
        var memory = groupConfig.memory,
            syncToStorage = groupConfig.syncToStorage,
            storage = groupConfig.storage,
            memorySessionKey = groupConfig.memorySessionKey;

        try {
          var groupDump = currentDump[groupName] = {};

          _getFields(groupName).forEach(function (_ref20) {
            var config = _ref20.config,
                name = _ref20.name,
                state = _ref20.state;
            var storageHandler = config.storageHandler,
                enableMemory = config.enableMemory;

            if (state) {
              var _state$visible = state.visible,
                  visible = _state$visible === void 0 ? true : _state$visible;

              if (storageHandler && visible && (memory ? enableMemory || memorySessionKey : true)) {
                groupDump[getStorageName(name, groupConfig, config)] = storageHandler(state);
              }
            }
          });

          if (syncToStorage && (!memory || initialized)) {
            var result = memory ? _objectSpread({}, JSON.parse(storage.getItem(syncToStorage))) : {};
            var toClear = storageToClear[groupName];

            if (toClear) {
              var set = new Set(Object.keys(toClear));
              Object.keys(result).forEach(function (key) {
                if (key.indexOf('form-group-') === 0) {
                  if (set.has(key.replace('form-group-', '').split('-')[0])) {
                    delete result[key];
                  }
                }
              });
              delete storageToClear[groupName];
            }

            storage.setItem(syncToStorage, JSON.stringify(_objectSpread(_objectSpread({}, result), groupDump)));
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
          storage.removeItem(syncToStorage);
        } // 在memory模式下，第一次change时不触发记忆
        // 触发对应组的onChange


        // 在memory模式下，第一次change时不触发记忆
        // 触发对应组的onChange
        var targetValue = fieldsToValue(_getFields(groupName));
        var onGroupChange = groups[groupName].onChange;
        onGroupChange && onGroupChange(fieldsToValue(_getFields(groupName))); // 触发对应组件的onChange

        // 触发对应组件的onChange
        var _iterator2 = _createForOfIteratorHelper(iteratee(renderList)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _step2.value,
                targetGroupName = _step2$value.groupName,
                onComponentChange = _step2$value.onChange;

            if (targetGroupName === groupName) {
              onComponentChange && onComponentChange(targetValue);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }); // 变化后清除open session

      // 变化后清除open session
      if (initialized) {
        sessionStorage.removeItem(openSessionKey);
      }

      initialized = true; // 查询时，埋点用户类型

      // 查询时，埋点用户类型
      try {
        forOwn(groups, function (_, groupName) {
          var value = fieldsToValue(_getFields(groupName));

          if (value && value.erpDeptSign) {
            _trackEvent({
              componentName: 'filter',
              locationName: 'erpDeptSign',
              eventName: 'query',
              eventValue: value.erpDeptSign
            });
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
  }),
      setField = _Group.setField,
      getField = _Group.getField,
      dispatch = _Group.dispatch,
      otherResult = _objectWithoutProperties(_Group, _excluded4);

  return _objectSpread({
    dispatch: dispatch,
    getField: getField,
    setField: setField,
    setProps: function setProps(groupName, fieldName, nextProps) {
      return setField(groupName, fieldName, {
        props: _objectSpread(_objectSpread({}, getField(groupName, fieldName).props), nextProps)
      });
    },
    dump: function dump() {
      return currentDump;
    },
    restore: function restore(groupName, image) {
      dispatch(RESTORE, {
        groupName: groupName,
        image: image
      });
    },
    open: function open(url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var target = arguments.length > 2 ? arguments[2] : undefined;
      var features = arguments.length > 3 ? arguments[3] : undefined;
      // 存储到session中
      sessionStorage.setItem(openSessionKey, JSON.stringify({
        path: parse(url).pathname,
        data: mapValue(currentDump, function (v, k) {
          return _objectSpread(_objectSpread({}, v), args === null || args === void 0 ? void 0 : args[k]);
        })
      })); // 打开新窗口

      window.open(url, target, features); // 清除session

      sessionStorage.removeItem(openSessionKey);
    }
  }, otherResult);
}
FormGroup.INIT = INIT;